// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Yx_7","requiredAsterisk":"Info_requiredAsterisk__x4u0E"};